import { render, staticRenderFns } from "./SystemInfoNewBtn.vue?vue&type=template&id=259c881c"
import script from "./SystemInfoNewBtn.vue?vue&type=script&lang=js"
export * from "./SystemInfoNewBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports